import { render, staticRenderFns } from "./BreedCrumbs.vue?vue&type=template&id=606ac952&"
import script from "./BreedCrumbs.vue?vue&type=script&lang=ts&"
export * from "./BreedCrumbs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports